import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense, lazy } from 'react'
import { RouteObject } from 'react-router'

export const PEER_POINTS_ELEMENT_ID = 'peerPointsRoute'
export const CELEBRATION_POINTS_ELEMENT_ID = 'celebrationPointsRoute'
export const POINTS_ELEMENT_ID = 'pointsRoute'

const PointsRoute = lazyWithRetries(() => import('.'))
const PeerToPeerRoute = lazyWithRetries(
  () => import('./pointsSetup/allocation/peerToPeer/PeerToPeer'),
)
const CelebrationRoute = lazyWithRetries(
  () => import('./pointsSetup/allocation/celeberation/Celebration'),
)
const PointBanksRoute = lazyWithRetries(
  () => import('./pointsSetup/allocation/pointBanks/PointBanks'),
)
const IndividualPointsReportingRoute = lazy(
  () => import('../../reports/pointsReporting/IndividualPointsReporting'),
)

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.individualPointsReporting(':memberId'),
    element: (
      <StandardPageLayout elementId="individualPointsReportingRoute" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <IndividualPointsReportingRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.points(':tab?'),
    element: (
      <StandardPageLayout elementId={POINTS_ELEMENT_ID} maxWidth={1440} title={<T _str="Points" />}>
        <Suspense fallback={<RouteLoading />}>
          <PointsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.pointsRules('peer'),
    element: (
      <StandardPageLayout
        elementId={PEER_POINTS_ELEMENT_ID}
        maxWidth={1080}
        title={<T _str="Peer-to-peer points" />}>
        <Suspense fallback={<RouteLoading />}>
          <PeerToPeerRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.pointsRules('celebration'),
    element: (
      <StandardPageLayout
        elementId={CELEBRATION_POINTS_ELEMENT_ID}
        maxWidth={1080}
        title={<T _str="Celebration points" />}>
        <Suspense fallback={<RouteLoading />}>
          <CelebrationRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.pointsRules('bank'),
    element: (
      <StandardPageLayout
        elementId="pointBanksRoute"
        maxWidth={1080}
        title={<T _str="Point banks" />}>
        <Suspense fallback={<RouteLoading />}>
          <PointBanksRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
